const UserRole = Object.freeze({
  ROLE_BASIC_USER: 'ROLE_BASIC_USER',
  ROLE_SYSTEM_ADMIN_USER: 'ROLE_SYSTEM_ADMIN_USER',
  ROLE_SUPPORT_ADMIN_USER: 'ROLE_SUPPORT_ADMIN_USER',
  ROLE_ANONYMOUS: 'ROLE_ANONYMOUS',
  ROLE_COMPANY_ADMIN_USER: 'ROLE_COMPANY_ADMIN_USER',
  ROLE_SELLER_ADMIN_USER: 'ROLE_SELLER_ADMIN_USER',
  ROLE_ACCOUNT_ADMIN_USER: 'ROLE_ACCOUNT_ADMIN_USER',
  ROLE_EXECUTIVE: 'ROLE_EXECUTIVE',
  ROLE_BUSINESS_USER: 'ROLE_BUSINESS_USER',
  ROLE_ANNOTATOR: 'ROLE_ANNOTATOR',
  ROLE_PRO_USER: 'ROLE_PRO_USER',
  ROLE_INTEGRATION_USER: 'ROLE_INTEGRATION_USER'
})
export default UserRole
export type UserRoleStrings = typeof UserRole[keyof typeof UserRole]
// RESERVE BELOW
